import { AppShell, NavbarVerticalMenuRoute } from '@wyz/ui';
import clsx from 'clsx';
import { isNil } from 'lodash-es';
import { Fragment } from 'react';
import { NavLink, useLocation } from 'react-router';
import { Trans } from '~/common/context';
import { useAccessControl } from '~/common/hooks';
import routes from '~/common/menu';
import { FeatureFlagEnum, TranslationKeys } from '~/common/types';

const Sidebar = () => {
  const { pathname } = useLocation();
  const acl = useAccessControl();

  const canUserAccess = (
    route: NavbarVerticalMenuRoute<keyof TranslationKeys, FeatureFlagEnum>,
  ): boolean => {
    if ('separator' in route && route.separator) {
      return true;
    }

    if ('children' in route && !isNil(route.children)) {
      return route.children.some(canUserAccess);
    }

    if (!isNil(route.features) && !acl.isEnabledFeatures(route.features)) {
      return false;
    }

    if (isNil(route.roles)) {
      return true;
    }
    return acl.isGranted(route.roles, 'affirmative');
  };
  return (
    <>
      {routes.map((route) => (
        <Fragment key={route.label}>
          {route.children && (
            <AppShell.Menu
              routes={route.children}
              renderMenuItem={(route) => (
                <AppShell.Item
                  icon={route.icon}
                  label={<Trans i18nKey={route.name} />}
                  externalTarget={route.externalTarget}
                />
              )}
              renderLink={(route, children) => (
                <NavLink
                  end={route.exact}
                  to={route.to}
                  className={({ isActive }) =>
                    clsx('nav-link', {
                      active: isActive,
                    })
                  }
                  data-cy={route.dataCy}
                  target={route.externalTarget ? '_blank' : undefined}
                >
                  {children}
                </NavLink>
              )}
              renderSeparator={(item) => (
                <li key={`${String(item.name)}.separator`} className='nav-item'>
                  <div className='mt-3 mb-2 navbar-vertical-label-wrapper row'>
                    <div className='navbar-vertical-label navbar-vertical-label col-auto'>
                      <Trans i18nKey={item.name} />
                    </div>
                    <div className='ps-0 col'>
                      <hr className='mb-0 navbar-vertical-divider' />
                    </div>
                  </div>
                </li>
              )}
              shouldRender={canUserAccess}
              getCurrentPath={() => pathname}
            />
          )}
        </Fragment>
      ))}
    </>
  );
};

export default Sidebar;
